import {
  POST_SESSION_BEGIN, POST_SESSION_FAILURE, POST_SESSION_SUCCESS, DELETE_SESSION_BEGIN, DELETE_SESSION_SUCCESS,
  DELETE_SESSION_FAILURE,
  FETCH_SESSION_BEGIN,
  FETCH_SESSION_SUCCESS,
  FETCH_SESSION_FAILURE, UPDATE_LOGIN_MESSAGE, UPDATE_RECAPTCHA_ID
} from "../actions/login";
import {AnyAction} from "redux";
import {LoginState} from "./index";
import {updateObject} from "../utils/miscUtils";

const initialState = {
  showRecaptcha: false,
  failedAttempts: 0,
  email: "",
  firstName: "",
  lastName: "",
  id: -1,
  superAdmin: false,
  message: null,
  recaptcha: 0,
  isSubmitted: false
};

const login = (state: LoginState = initialState, action: AnyAction) => {

  switch(action.type) {
    case UPDATE_RECAPTCHA_ID:
      return updateObject(state, {
        recaptcha: action.id
      })
    case UPDATE_LOGIN_MESSAGE:
      return updateObject(state, {
        message: action.message
      })
    case POST_SESSION_BEGIN:
      return updateObject(state, {
        message: null,
        isSubmitted: true
      })
    case POST_SESSION_FAILURE:
    case FETCH_SESSION_FAILURE:
      return updateObject(state, {
        failedAttempts: action.failedAttempts,
        showRecaptcha: action.showRecaptcha,
        isSubmitted: false
      })
    case POST_SESSION_SUCCESS:
    case FETCH_SESSION_SUCCESS:
      const sessionData = action.payload.session;

      return updateObject(state, {
        failedAttempts: 0,
        showRecaptcha: false,
        email: sessionData.email,
        firstName: sessionData.firstName,
        lastName: sessionData.lastName,
        id: sessionData.id,
        superAdmin: sessionData.superAdmin,
        isSubmitted: false
      })
    case DELETE_SESSION_SUCCESS:
    case DELETE_SESSION_FAILURE:
      const clearedState = updateObject(initialState, {
        recaptcha: state.recaptcha
      })
      return updateObject(state, clearedState)
    case FETCH_SESSION_BEGIN:
    case DELETE_SESSION_BEGIN:
    default:
      return state
  }
};

export default login;
